/**
 * Integrytas Group — DDM (Demo Data Mirror), mobile presentation layer.
 *
 * MobileDemoBanner — the strip that says, on every mobile screen, that the data
 * on it is the sandbox and not production.
 *
 * §16 makes mobile its own presentation layer, so this is a mobile-native
 * component rather than the desktop <DdmDemoBanner>: it sits under the app bar
 * where a phone user's eye already goes for context, uses the shell's own
 * `m-*` styling, and is sized for a 375px viewport rather than a 1440px one.
 * The desktop banner's full sentence does not fit here, so the wording is
 * shorter — the same fact, told in the space available.
 *
 * It exists because mobile previously had NO demo indication at all. The data
 * layer switched (api_client sends x-ddm-schema regardless of surface) while
 * the mobile UI stayed identical, so a phone could be reading and writing the
 * mirror with nothing on screen to say so.
 */

import { Database } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDdmSchema } from '../../lib/ddm_mode';

export function MobileDemoBanner() {
  const { t } = useTranslation();
  if (useDdmSchema() !== 'demo') return null;

  return (
    <div className="m-demo-flag" role="status">
      <Database size={13} />
      {t('mobile.ddm.banner', 'Demo data — not production')}
    </div>
  );
}
